import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-2" }

import ClusterListItem from '@/components/Search/LeftPane/ClusterListItem.vue';
import { Community } from '@/models/Search';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  props: {
  clusters: {
    type: Object as PropType<Community[]>,
    required: true,
  },
  clusterColors: {
    type: Object as PropType<Record<number, string>>,
    required: true,
  },
},
  emits: ['select', 'unselect'],
  setup(__props) {





const store = useStore();

const currentNodeType = computed(() => store.getters['search/currentNodeType'] as string);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.clusters, (cluster, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "py-1"
      }, [
        _createVNode(ClusterListItem, {
          cluster: cluster,
          clusterColor: __props.clusterColors[parseInt(cluster.id)],
          nodeType: _unref(currentNodeType),
          onSelect: _cache[0] || (_cache[0] = (clusterId) => _ctx.$emit('select', clusterId)),
          onUnselect: _cache[1] || (_cache[1] = (clusterId) => _ctx.$emit('unselect', clusterId))
        }, null, 8, ["cluster", "clusterColor", "nodeType"])
      ]))
    }), 128))
  ]))
}
}

})